import styled from "styled-components";
import Typography from '@mui/material/Typography';

export const Logo = styled.img`
    background: no-repeat center center;
    width: 100px;
    height: 64px;
    margin-top: 0px;
    display: block;
    background-size: cover;
`

export const ThanksImg = styled.img`
    background: no-repeat center center;
    margin-top: -20px;
    width: auto;
    height: 32px;
    display: block;
    background-size: cover;
`

export const MainContainer = styled.div`
    width: calc(100vw - 36px);
    height: 100vh;
    padding-left: 12px;
    padding-right: 24px;
    padding-top: 2px;
`

export const CenteringContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`

export const BottomCenteringContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 100%;
    margin: 24px;
`

export const StyledTitle = styled(Typography)`
    font-size: 32px !important;
    font-weight: bold;
`

export const SpaceBetweenContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 0;
`

export const DescriptionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 12px;
    font-family: Hind Vadodara, Lucida Sans Unicode !important;
    letter-spacing: 0.8px;
`

export const DescriptionText = styled.div`
    display: flex;
    gap: 4px;
    font-weight: ${({isBold}) => isBold ? 'bold' : 'inherit'};
    font-size: 12px;
`

export const TableContainer = styled.div`
    margin-top: 24px;
    margin-bottom: 24px;
    padding-top: 6px;
    padding-bottom: 12px;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
`

export const BoldDescriptionText = styled.div`
    font-size: 12px;
    font-weight: bold;
    font-family: Hind Vadodara, Lucida Sans Unicode !important;
    letter-spacing: 0.8px;
    margin-bottom: 18px;
`

export const TableFlexContainer = styled.div`
    display: flex;
`

export const LeftFlexGrow = styled.div`
    width: 64%;
`

export const MiddleFlexGrow = styled.div`
    width: 18%;
    display: flex;
    justify-content: center;
`

export const RightFlexGrow = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: right;
    width: 18%;
`
